import { HEADER_PORTAL_ID } from "modules/shared/lib/constants"
import { useEffect, useState } from "react"
import { createPortal } from "react-dom"

type HeaderButtonsProps = {
  children: React.ReactNode
  identifier?: string
}

export function HeaderButtons({ identifier, children }: HeaderButtonsProps) {
  const [portalTargetElement, setPortalTargetElement] = useState<HTMLElement | null>(
    () => document.querySelector(`#${HEADER_PORTAL_ID}`) as HTMLElement | null,
  )

  useEffect(() => {
    if (portalTargetElement) {
      // If target already found, bail out
      return
    }

    const checker = setInterval(() => {
      const target = document.querySelector(`#${HEADER_PORTAL_ID}`)
      if (target) {
        setPortalTargetElement(target as HTMLElement)
        clearInterval(checker)
      }
    }, 100)

    const timeoutId = setTimeout(() => {
      clearInterval(checker)
    }, 1000)

    return () => {
      clearInterval(checker)
      clearTimeout(timeoutId)
    }
  }, [portalTargetElement]) // Re-run if portalTargetElement was null

  if (portalTargetElement && children) {
    return createPortal(children, portalTargetElement, identifier)
  }

  return null
}
